import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import TableImage from "../../shared/Table/TableImage";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import PrimaryButton from "../../shared/Button/PrimaryButton";
import { Paginator } from "primereact/paginator";
import moment from "moment";
import { Tag } from "primereact/tag";
import { Button } from "primereact/button";
import api from "../../services/api";
import Constants from "../../services/constants";
import { exportTableToCsv } from "../../utils/exportTableCsv";

export default function ExpiredMembershipUsersTable({
    heading,
    allExpiredMemberships,
    loading,
    history,
    search,
    setSearch,
    page,
    limit,
    totalRecords,
    setPage,
    setLimit,
}) {
    const [selectedRow, setSelectedRow] = useState([]);
    const [currentPage, setCurrentPage] = useState(page);
    const [pageSize, setPageSize] = useState(limit);
    const [exporting, setExporting] = useState(false);

    // const actions = (d) => {
    //     return (
    //         <div className="flex justify-content-around">
    //             <i className="pi pi-eye cursor-pointer text-dark" onClick={() => history(`/call-logs/view/${d._id}`)}></i>
    //         </div>
    //     );
    // };
 
    const dateFilterTemplate = (options) => {
        return (
            <Calendar
                value={options.value}
                onChange={(e) => {
                    options.filterCallback(e.value, options.index);
                }}
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
                mask="99/99/9999"
            />
        );
    };
 
    const filters = {
        time: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
        subscriptionExpireOn: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    };
 
    const formatDate = (date) => {
        return moment(date).format("MMMM Do YYYY, h:mm:ss a");
 
        // return date?.toLocaleDateString?.("en-US", {
        //     day: "2-digit",
        //     month: "2-digit",
        //     year: "numeric",
        // });
    };
 
    const caller = (data) => {
        const userId = data?.caller?.userId;
        const userDBId = data?.caller?._id;
        const userPhone = data?.caller?.countryCode && data?.caller?.mobile ? `${data.caller.countryCode}${data.caller.mobile}` : null;
 
        return (
            (
                <span style={{ cursor: "pointer" }} className="link" onClick={() => history(`/user/view/${userDBId}`)}>
                    {userId} {userPhone ? `(${userPhone})` : null}
                </span>
            ) ?? null
        );
    };
 
    const reciever = (data) => {
        const userId = data?.reciever?.userId;
        const userDBId = data?.reciever?._id;
        const userPhone = data?.reciever?.countryCode && data?.reciever?.mobile ? `${data.reciever.countryCode}${data.reciever.mobile}` : null;
 
        return (
            (
                <span style={{ cursor: "pointer" }} className="link" onClick={() => history(`/user/view/${userDBId}`)}>
                    {userId} {userPhone ? `(${userPhone})` : null}
                </span>
            ) ?? null
        );
    };
 
    const vehicleNumberTemplate = (data) => {
        const vehicleNumber = data?.vehicleDetails?.vehicleNumber;
        return vehicleNumber ?? null;
    };
 
    // Function to handle pagination change
    const onPageChange = (event) => {
        setCurrentPage(event.first / event.rows + 1);
        setPage(event.page + 1);
        setLimit(event.rows);
        setPageSize(event.rows);
    };
 
    const getSeverity = (status) => {
        switch (status) {
            case "COMPLETED":
                return { rowSeverity: "success", value: "Active" };
            case "NOTANSWERED":
                return { rowSeverity: "info", value: "Not Answered" };
            case "ACTIVE":
                return { rowSeverity: "warning", value: "Rejected" };
            case "REJECTED":
                return { rowSeverity: "danger", value: "Rejected" };
            default:
                return { rowSeverity: null, value: null };
        }
    };
 
    const callStatusTemplate = (rowData) => {
        const { rowSeverity, value } = getSeverity(rowData.status);
        return <Tag value={value} severity={rowSeverity} />;
    };
 
    const userDetails = (r) => {
        const userId = r?.userId;
        const userDBId = r?._id;
        return (
            (
                <span style={{ cursor: "pointer" }} className="link" onClick={() => history(`/user/view/${userDBId}`)}>
                    {userId}
                </span>
            ) ?? null
        );
    };
 
    // See CallLogsTable.jsx for why this bypasses the redux action.
    const exportAll = async () => {
        setExporting(true);
        try {
            const url = `${Constants.END_POINT.EXPIRED_MEMBERSHIPS}?page=1&limit=10000&search=${encodeURIComponent(search || "")}`;
            const res = await api("get", url);
            const rows = res?.data?.data || [];
            exportTableToCsv("expired-memberships.csv", rows, [
                { header: "Name", value: (row) => [row.firstName, row.lastName].filter(Boolean).join(" ") || "-" },
                { header: "Vehicle Number", value: vehicleNumberTemplate },
                { header: "Plan Name", value: (row) => row?.subscriptionDetails?.planName || "-" },
                { header: "Expired At", value: (row) => formatDate(row?.subscriptionDetails?.endAt) },
            ]);
        } finally {
            setExporting(false);
        }
    };

    return (
        <>
            <div className="col-12">
                <div className="card">
                    <div className="flex justify-content-between mb-4">
                        <h5>{heading}</h5>
                        <div className="flex align-items-center">
                            {setSearch ? (
                                <div className="p-input-icon-left mx-2">
                                    <i className="pi pi-search" />
                                    <InputText value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" />
                                </div>
                            ) : null}
                            <Button
                                label="Export CSV"
                                icon="pi pi-download"
                                onClick={exportAll}
                                loading={exporting}
                                disabled={!totalRecords}
                                severity="success"
                            />
                        </div>
                    </div>
                    <DataTable
                        // paginator
                        value={allExpiredMemberships}
                        selection={selectedRow}
                        onSelectionChange={(e) => setSelectedRow(e.value)}
                        selectionMode="checkbox"
                        filter={filters}
                        filterDisplay="menu"
                        loading={loading}
                        emptyMessage="No Expired Memberships found."
                        className=""
                        showGridlines
                        first={(currentPage - 1) * pageSize}
                        rows={pageSize}
                        totalRecords={totalRecords || 0}
                        onPage={onPageChange}
                    >
                        {/* <Column body={userDetails} header="User Id"></Column> */}
                        <Column body={(rowData) => [rowData.firstName, rowData.lastName].filter(Boolean).join(" ") || "-"} header="Name"></Column>
                        <Column body={vehicleNumberTemplate} header="Vehicle Number"></Column>
                        <Column field="subscriptionDetails.planName" header="Plan Name"></Column>
                        <Column
                            header="Expired At"
                            field="endAt"
                            dataType="date"
                            style={{ width: "250px" }}
                            filterMatchMode="dateIs"
                            showFilterMatchModes={true}
                            body={(rowData) => formatDate(rowData.subscriptionDetails.endAt)}
                            filter
                            filterElement={dateFilterTemplate}
                        />
                        {/* <Column body={actions} style={{ width: "80px" }} header="Action"></Column> */}
                    </DataTable>
                    <Paginator
                        first={(currentPage - 1) * pageSize}
                        rows={pageSize}
                        totalRecords={totalRecords || 0}
                        onPageChange={onPageChange}
                        rowsPerPageOptions={[10, 20, 30]}
                    />
                </div>
            </div>
        </>
    );
}